import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { Company } from ".";
import { Role } from "./role";
import { Status } from "./status";
import { User } from "./user";

export class UserRoleId {
    user: User = new User();
    role: Role = new Role();
    company: Company = new Company();
}

export class UserRole {
    id: UserRoleId = new UserRoleId();
    dateStart: Date | null;
    dateEnd: Date | null;
    status: Status = new Status();
    isEditable: boolean = false;
    isNew: boolean = false;
    /** Clave estable para el trackBy de la grilla, usada en las filas nuevas que aún no tienen usuario */
    rowKey?: string;
    /** Copia de las fechas previa a la edición, para poder revertirlas al cancelar */
    dateBackup?: { dateStartParse: NgbDate | null; dateEndParse: NgbDate | null };

    private _dateStartParse: NgbDate | null;
    private _dateEndParse: NgbDate | null;

    get dateStartParse(): NgbDate {
        return this._dateStartParse;
    }

    set dateStartParse(date: NgbDate) {
        this.dateStart = date ? new Date(date.year, date.month - 1, date.day) : null;
        this._dateStartParse = date;
    }

    get dateEndParse(): NgbDate {
        return this._dateEndParse;
    }

    set dateEndParse(date: NgbDate) {
        this.dateEnd = date ? new Date(date.year, date.month - 1, date.day) : null;
        this._dateEndParse = date;
    }

    get combinationId(){
        return `${this.id?.user?.id}`;
    }
}
